// import React from 'react'

// function GetQute() {
//     return (
//         <div>GetQute</div>
//     )
// }

// export default GetQute



import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import Swal from "sweetalert2";

function GetQute() {
    // Static farmer data
    const staticFarmers = [
        {
            _id: "1",
            fullname: "darshan",
            user_id: "user1",
            name: "John Doe",
            email: "john@example.com",
            phoneNumber: "1234567890",
            pincode: "560001",
            billingCycle: "Monthly",
            monthlyUnits: "1000",
            suggestion: "Solar Panel 5kW",
            subtotal: "₹50,000",
            finalAmount: "₹45,000",
            createdAt: "2023-05-15T10:00:00Z",
            status: "Approved"
        },
        {
            _id: "2",
            fullname: "darshan",

            user_id: "user2",
            name: "Jane Smith",
            email: "jane@example.com",
            phoneNumber: "9876543210",
            pincode: "560002",
            billingCycle: "Quarterly",
            monthlyUnits: "1500",
            suggestion: "Solar Panel 7kW",
            subtotal: "₹70,000",
            finalAmount: "₹63,000",
            createdAt: "2023-06-20T11:30:00Z",
            status: "Pending"
        },
        {
            _id: "3",
            fullname: "darshan",

            user_id: "user3",
            name: "Robert Johnson",
            email: "robert@example.com",
            phoneNumber: "8765432109",
            pincode: "560003",
            billingCycle: "Monthly",
            monthlyUnits: "800",
            suggestion: "Solar Panel 3kW",
            subtotal: "₹30,000",
            finalAmount: "₹27,000",
            createdAt: "2023-07-10T09:15:00Z",
            status: "Rejected"
        },
        {
            _id: "4",
            fullname: "darshan",

            user_id: "user4",
            name: "Sarah Williams",
            email: "sarah@example.com",
            phoneNumber: "7654321098",
            pincode: "560004",
            billingCycle: "Monthly",
            monthlyUnits: "1200",
            suggestion: "Solar Panel 5kW",
            subtotal: "₹50,000",
            finalAmount: "₹45,000",
            createdAt: "2023-08-05T14:45:00Z",
            status: "Approved"
        },
        {
            _id: "5",
            fullname: "darshan",
            user_id: "user5",
            name: "Michael Brown",
            email: "michael@example.com",
            phoneNumber: "6543210987",
            pincode: "560005",
            billingCycle: "Quarterly",
            monthlyUnits: "2000",
            suggestion: "Solar Panel 10kW",
            subtotal: "₹1,00,000",
            finalAmount: "₹90,000",
            createdAt: "2023-09-12T16:20:00Z",
            status: "Pending"
        }
    ];

    const [farmers, setFarmers] = useState(staticFarmers);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterStatus, setFilterStatus] = useState("All");
    const changeRef = useRef(Math.random());
    const { id } = useParams();

    const fetchFarmerFarmDataInit = async () => {
        try {
            // Using static data instead of API call
            const sortedData = [...staticFarmers].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setFarmers(sortedData);
        } catch (error) {
            console.error("Error processing farmers data:", error);
        }
    };

    useEffect(() => {
        fetchFarmerFarmDataInit();
    }, []);

    const farmerstatuses = ["All", ...new Set(staticFarmers.map((farm) => farm.status || "Pending"))];

    const filteredFarmers = farmers.filter((farm) => {
        const query = searchQuery.trim().toLowerCase();
        const statusMatch = filterStatus === "All" || farm.status === filterStatus;
        const nameMatch = farm.name && farm.name.toLowerCase().includes(query);
        const emailMatch = farm.email && farm.email.toLowerCase().includes(query);
        const phoneMatch = farm.phoneNumber && farm.phoneNumber.includes(query);
        const pincodeMatch = farm.pincode && farm.pincode.includes(query);

        return statusMatch && (nameMatch || emailMatch || phoneMatch || pincodeMatch);
    });

    const totalPages = Math.ceil(filteredFarmers.length / itemsPerPage);
    const indexOfFirstFarm = (currentPage - 1) * itemsPerPage;
    const indexOfLastFarm = currentPage * itemsPerPage;
    const currentFarmers = filteredFarmers.slice(indexOfFirstFarm, indexOfLastFarm);
    const indexOfFirstItem = indexOfLastFarm - itemsPerPage;

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(1);
        }
    }, [filteredFarmers, currentPage, totalPages]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDeleteClick = async (id, user_id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                const updatedFarmers = farmers.filter(farmer => farmer._id !== id);
                setFarmers(updatedFarmers);
                Swal.fire("Deleted!", "The farmer has been deleted.", "success");
            } catch (error) {
                Swal.fire("Error!", "Failed to delete the farmer.", "error");
            }
        }
    };

    return (
        <div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">Get Qute List</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Dashboard
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Get Qute</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select className="form-select form-select-sm w-auto" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={filteredFarmers.length}>All</option>
                        </select>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        {/* <div className="icon-field">
                            <input type="text" className="form-control form-control-sm w-auto" placeholder="Search by Name, Email, Phone or Pincode" onChange={handleSearchChange} />
                            <span className="icon">
                                <Icon icon="ion:search-outline" />
                            </span>
                        </div> */}
                        <Link to="" className="btn btn-primary border-0" style={{ backgroundColor: "#f1c40f" }}>
                            <Icon
                                icon="mdi:plus" className="icon text-xl"
                            />
                            Add
                        </Link>
                    </div>
                </div>

                <div className="card-body" style={{ overflowX: "auto" }}>
                    <table className="table bordered-table mb-0">
                        <thead>
                            <tr>
                                <th>S.L</th>
                                <th>Full Name</th>
                                <th>Property Category</th>
                                <th>Electricity Provider</th>
                                <th>Panel Brand</th>
                                <th> Inverter Brand</th>
                                <th>Subsidy</th>
                                <th>Final Amount(Approx.)</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentFarmers.length === 0 ? (
                                <tr>
                                    <td colSpan="10" className="text-center">No farmers found.</td>
                                </tr>
                            ) : (
                                currentFarmers.map((farmer, index) => (
                                    <tr key={farmer._id}>
                                        <td>{indexOfFirstItem + index + 1}</td>
                                        <td>{farmer.fullname || "N/A"}</td>
                                        <td>{farmer.billingCycle || "N/A"}</td>
                                        <td>{farmer.monthlyUnits || "N/A"}</td>
                                        <td>{farmer.suggestion || "N/A"}</td>
                                        <td>{farmer.subtotal || "N/A"}</td>
                                        <td>{farmer.finalAmount || "N/A"}</td>
                                        <td>{farmer.finalAmount || "N/A"}</td>
                                        <td>{farmer.createdAt ? new Date(farmer.createdAt).toLocaleDateString() : "N/A"}</td>

                                        <td>
                                            <Link to={`/customers/get-quote/detail`} className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center">
                                                <Icon icon="iconamoon:eye-light" />
                                            </Link>
                                            <Link onClick={() => handleDeleteClick(farmer._id, farmer.user_id)} className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center border-0">
                                                <Icon icon="mingcute:delete-2-line" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                        <span>Showing {indexOfFirstFarm + 1} to {Math.min(indexOfLastFarm, filteredFarmers.length)} of {filteredFarmers.length} entries</span>
                        <nav>
                            <ul className="pagination">
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetQute;


